export const TASK_TYPES = {
  INSTALLATION: "INSTALLATION",
  SUPPORT: "SUPPORT",
};